import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { SelectedFilterChipParams } from '../../../../../shared/types/common';
import { sentenceCase } from '../../../../../shared/utils/functions';
import isNumber from 'lodash/isNumber';
import { FC } from 'react';

const Label = styled(Typography)(
  ({ theme }) => `
  &.Typography-root {
    color: ${theme.palette.primary.main};
    text-transform: uppercase;
    white-space: normal;
  }`,
);

const StyledChip = styled(Chip)(
  ({ theme }) => `
  &.MuiChip-root {
    background-color: ${theme.palette.primary.light};
    color: ${theme.palette.primary.main};
  }`,
);

type Props = SelectedFilterChipParams & {
  onDelete: (params: SelectedFilterChipParams) => void;
};

const localize = <T,>(value: T): T | string => {
  if (isNumber(value)) {
    return value.toLocaleString('en-US');
  }
  return value;
};

export const SelectedFilterChip: FC<Props> = ({
  value,
  category,
  onDelete,
  overwriteLabel,
}) => {
  const categoryText = sentenceCase(category);
  const valueText = Array.isArray(value)
    ? value.map(localize).join(' - ')
    : String(value);

  return (
    <StyledChip
      label={
        <Label variant='caption'>
          <b>{overwriteLabel?.[0] || categoryText}:</b>{' '}
          {overwriteLabel?.[1] || valueText}
        </Label>
      }
      onDelete={() => {
        onDelete({ value, category });
      }}
    />
  );
};
